import React from 'react';
import styles from './index.module.scss';
import { formatBoldTextHTML } from '../../../../utils/formatBoldText';

const UnknownLongText = ({
  contentData,
  contentText,
  contentName,
  imgName,
  imgsNames,
  videoName,
}) => {
  return (
    <div className={styles.unknownLongText}>
      <h2 className={styles.title}>Неизвестный Длинный Текст</h2>
      <p className={styles.description}>Компонент для неизвестного длинного текста</p>
      {contentText && contentText !== 'none' && (
        <div className={styles.contentText}>
          {contentText?.split('\n').map((line, lineIndex) => {
            const formattedLine = formatBoldTextHTML(line);
            return (
              <p
                key={lineIndex}
                dangerouslySetInnerHTML={{ __html: formattedLine }}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UnknownLongText;
